import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const previousPathname = useRef(pathname);

  useEffect(() => {
    // Scroll to top whenever the pathname changes (different page navigation)
    if (previousPathname.current !== pathname) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      previousPathname.current = pathname;
    }
  }, [pathname]);

  useEffect(() => {
    // Handle clicks on navigation links, including same-page clicks
    const handleNavClick = (event) => {
      // Look for clicks on elements that are likely navigation links
      const target = event.target;
      const linkElement = target.closest('a, button, [role="button"]');
      
      if (linkElement) {
        // Check if it's inside a navigation area or has navigation-related attributes
        const isInNav = linkElement.closest('nav') || 
                       linkElement.closest('.header-nav') || 
                       linkElement.closest('.mobile-row-2') ||
                       linkElement.closest('.header-actions') ||
                       linkElement.closest('.mobile-row-3');
        
        // Check if it's a React Router Link by looking for the to prop
        const hasToProp = linkElement.getAttribute('to') || 
                         linkElement.closest('[to]') ||
                         linkElement.querySelector('[to]');
        
        // Check if it's a regular anchor with href
        const hasHref = linkElement.getAttribute('href');
        
        if (isInNav || hasToProp || (hasHref && hasHref.startsWith('/'))) {
          // Always scroll to top for navigation clicks
          setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }, 50);
        }
      }
    };

    // Add event listener to document with capture to catch all clicks
    document.addEventListener('click', handleNavClick, true);

    // Cleanup
    return () => {
      document.removeEventListener('click', handleNavClick, true);
    };
  }, []);

  return null;
};

export default ScrollToTop;
